// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';

import router from './router';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/base.css';
import * as echarts from 'echarts'; // 在import的后面，echarts的前面加一个 * as
Vue.prototype.$echarts = echarts;
import * as echarts5 from 'echarts5'; // 在import的后面，echarts的前面加一个 * as
Vue.prototype.$echarts5 = echarts5;
import './components/echarts-wordcloud.js';
import App from './App';
Vue.use(ElementUI);
import AFTableColumn from 'af-table-column';
Vue.use(AFTableColumn);
import VueMarquee from 'vue-marquee-component';

Vue.use(VueMarquee);
Vue.config.productionTip = false;
import Bus from './components/eventbus';
Vue.prototype.$bus = Bus;
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>',
});

//埋点
router.beforeEach((to, from, next) => {
	try {
		LogCollection.end();
	} catch (e) {}
	next();
});

router.afterEach((to, from) => {
	try {
		LogCollection.init();
	} catch (e) {}
	// next();
});



// WEBPACK FOOTER //
// ./src/main.js